import React, { useEffect, useState } from "react";
import { Row, Col, Button, FloatingLabel, Form, Stack, Container, Spinner } from "react-bootstrap";
import { User } from "../../../../types/user";
import SupportCard from "./SupportCard";
import EditSupport from "./EditSupport";
import { fetchSupportUsers, fetchUserCaseSupports, postSupportsData } from "../../../../services/httpClient";
import { useParams } from "react-router-dom";
import ToastMsg from "../../../ui/ToastMsg";

interface SupportUsersState {
  editUser: boolean;
  setEditUser: any;
  currentUser: User | undefined;
  setCurrentUser: any;
  addSupport: boolean;
  setAddSupport: any;
  getData: boolean;
  myCase: boolean;
}

const SupportUsers = ({
  editUser,
  setEditUser,
  currentUser,
  setCurrentUser,
  addSupport,
  setAddSupport,
  getData,
  myCase,
}: SupportUsersState) => {
  const { id } = useParams();
  const [support, setSupport] = useState<User[]>([]);
  const [possibleSupport, setPossibleSupport] = useState<User[]>([]);
  const [selectedSupport, setSelectedSupport] = useState<string>();
  const [releaseDoc, setReleaseDoc] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");

  useEffect(() => {
    if (getData) {
      setIsLoading(true);
      getSupport();
    }
  }, [getData]);

  const getSupport = () => {
    fetchUserCaseSupports(id)
      .then((res: any) => {
        const users = res[0].data;
        setSupport(users);
        setIsLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  //switch to get support users
  const onClickAddSupport = () => {
    setAddSupport(true);
    var userList: any[] = [];

    fetchSupportUsers()
      .then((res: any) => {
        res[0].data.map((i: any) => {
          userList.push(i);
        });

        userList = userList.filter((item1) => !support.some((item2) => item1.id === item2.user_id));
        setPossibleSupport(userList);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const onClickCancelAddSupport = () => {
    setAddSupport(false);
    setSelectedSupport("");
  };

  const onClickSaveSupport = () => {
    const supportPerson = possibleSupport.filter((obj) => {
      const fullname = obj.firstname + " " + obj.lastname;
      return fullname === selectedSupport;
    });
    postSupportsData(id, supportPerson[0].id).then((res: any) => {
      setAddSupport(false);
      getSupport();
      setShowToast(true);
      setToastText("Support Added");
      setToastBody(supportPerson[0].firstname + " " + supportPerson[0].lastname);
    });
  };

  const formatSupport = (i: any) => {
    if (i.organization) {
      return i.firstname + " " + i.lastname + " - " + i.organization;
    } else {
      return i.firstname + " " + i.lastname;
    }
  };

  return (
    <>
      <ToastMsg showToast={showToast} setShowToast={setShowToast} toastText={toastText} toastBody={toastBody} />

      {isLoading ? (
        <Container>
          <Button size="sm" className="spinner-button spinner-button-main">
            <Spinner animation="border" style={{ color: "#F6893D" }} />
          </Button>
        </Container>
      ) : (
        <>
          <Row>
            <Col>
              <h4 className="mb-0 app-header-text">Support Member(s)</h4>
            </Col>
          </Row>
          <Row>
            {support.length === 0 ? (
              <p className="mt-2">No Current Support Members</p>
            ) : (
              support.map((user: User) => (
                <Col xs={8} sm={8} md={6} lg={6} xl={4} key={user.id} className="pb-3 h-100">
                  <SupportCard
                    user={user}
                    setEditMember={setEditUser}
                    currentMember={currentUser}
                    setCurrentMember={setCurrentUser}
                    setRelease={setReleaseDoc}
                    setAddSupport={setAddSupport}
                  />
                </Col>
              ))
            )}
          </Row>

          {editUser === true && (
            <EditSupport
              user={currentUser}
              fetchSupports={getSupport}
              setEditMember={setEditUser}
              setCurrentMember={setCurrentUser}
              currentMember={currentUser}
              release={releaseDoc}
              setRelease={setReleaseDoc}
              setShowToast={setShowToast}
              setToastText={setToastText}
              setToastBody={setToastBody}
              myCase={myCase}
            />
          )}

          {editUser !== true && (
            <Row>
              <Col className="col-3">
                {myCase && (
                  <Button className="app-primary-color button" onClick={() => onClickAddSupport()} disabled={addSupport}>
                    Add Support
                  </Button>
                )}
              </Col>
            </Row>
          )}

          {addSupport === true && (
            <Row className="align-items-center">
              <Col className="col-5">
                <FloatingLabel controlId="floatingInput" label="Support Users">
                  <Form.Select className="decorated" value={selectedSupport} onChange={(e: any) => setSelectedSupport(e.target.value)}>
                    <option key={0}>Select from the following</option>
                    {possibleSupport.map((i: any) => (
                      <option key={i.id} value={i.firstname + " " + i.lastname}>
                        {formatSupport(i)}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col className="col-3">
                <Stack direction="horizontal" gap={3}>
                  <Button className="app-secondary-color button" onClick={() => onClickSaveSupport()} disabled={!selectedSupport}>
                    Add
                  </Button>
                  <div className="vr" />
                  <Button className="app-primary-color button" onClick={() => onClickCancelAddSupport()}>
                    Cancel
                  </Button>
                </Stack>
              </Col>
            </Row>
          )}
        </>
      )}
    </>
  );
};

export default SupportUsers;
